export default __webpack_public_path__ + "static/media/image_9.5145f5e3.jpg";